/**
*功能名称：审批退回
*创 建 人：弋强
*日    期：2022/08/18 14:18:33
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {

    }
})
export default class ApproveReturn extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    /**
     * 已完成流程步骤
     */
    @Prop({ default: () => ([]) })
    aboveSteps?: any[];
    @Prop({ default: true })
    showStep!: Boolean; //是否显示退回步骤

    returnModel: any = {
        msg: '拒绝',
        method: 'start',
        step: '',
        taskId: ''
    }

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {
        this.changeMethod();
    }

    //#endregion 事件定义区

    //#region 方法定义区

    async changeMethod() {
        if (this.returnModel.method == 'start' || this.returnModel.method == 'custom') {
            this.returnModel.step = this.aboveSteps![0].NodeId
        } else if (this.returnModel.method == 'previous') {
            this.returnModel.step = this.aboveSteps![this.aboveSteps!.length - 1].NodeId;
        }
    }

    /**
     * 获取数据
     * @returns 
     */
    getData() {
        return this.returnModel;
    }

    //#endregion 方法定义区
}